import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const staff: AppRouteModule = {
  path: '/staff',
  name: 'Staff',
  component: LAYOUT,
  redirect: '',
  meta: {
    icon: 'icon-yuangongguanli',
    title: '员工管理',
    code: 'B0501,B0502,B030201,B03030,B030301',
  },
  children: [
    {
      path: '/staff/scoring',
      name: 'StaffScoring',
      component: () => import('/@/views/staff/scoring/index.vue'),
      meta: {
        title: '员工评分',
        code: 'B0501',
      },
    },
    {
      path: '/staff/ban',
      name: 'StaffBan',
      component: () => import('/@/views/staff/ban/index.vue'),
      meta: {
        title: '封号记录',
        code: 'B0502',
      },
    },
    {
      path: '/staff/user',
      name: 'StaffUsers',
      component: () => import('/@/views/staff/user/index.vue'),
      meta: {
        title: '用户管理',
        code: 'B030201,B03030,B030301',
      },
    },
  ],
};
export default staff;
